import React from 'react';
import FAQBase from './FAQBase';

const questions = [
  {
    question: 'What is considered "my child"?',
    answer:
      '"My child" generally refers to biological or legally adopted children as defined under applicable state law. In many cases, stepchildren or foster children may not be treated as biological or legally adopted children unless they are specifically named in estate planning documents.',
  },
  {
    question:
      'If someone named in my documents moves or changes their name after becoming married, do I need to update the information?',
    answer:
      "Minor changes, such as a new address or last name, do not always require document updates, but it's a good idea to review your plan periodically to make sure it still clearly identifies the intended person. You can come back to update your estate plan online as needed.",
  },
];

const FamilyFAQ = () => <FAQBase questions={questions} />;

export default FamilyFAQ;
